import { render, staticRenderFns } from "./igt-progress-bar.vue?vue&type=template&id=5cd368c3&scoped=true&"
import script from "./igt-progress-bar.vue?vue&type=script&lang=js&"
export * from "./igt-progress-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd368c3",
  null
  
)

export default component.exports